var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCalendrier = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "144.000000pt",
    height: "135.000000pt",
    viewBox: "0 0 144.000000 135.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,135.000000) scale(0.100000,-0.100000)",
    fill: "#5270A9",
    stroke: "none"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M335 1318 c-2 -7 -6 -38 -7 -68 l-3 -55 -105 -5 c-58 -3 -113 -10 -123 -14 -10 -5 -27 -26 -37 -47 -19 -36 -20 -61 -20 -546 1 -536 0 -526 47 -551 30 -16 1241 -17 1276 -1 14 6 30 22 36 36 8 16 11 179 11 524 0 476 -1 502 -20 538 -10 21 -27 42 -37 47 -10 4 -65 11 -123 14 l-105 5 -5 65 c-5 64 -5 65 -35 65 -30 0 -30 -1 -35 -65 l-5 -65 -320 0 -320 0 -5 65 c-5 62 -6 65 -33 68 -16 2 -29 -2 -32 -10z m30 -313 c28 0 30 3 33 39 l3 38 25 -23 c50 -47 10 -139 -61 -139 -40 0 -85 45 -85 84 0 17 10 40 23 54 l22 24 5 -39 c5 -34 8 -38 35 -38z m720 0 c28 0 30 3 33 39 l3 38 25 -23 c50 -47 10 -139 -61 -139 -40 0 -85 45 -85 84 0 17 10 40 23 54 l22 24 5 -39 c5 -34 8 -38 35 -38z m255 -540 l0 -365 -615 0 -615 0 0 365 0 365 615 0 615 0 0 -365z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M490 675 l0 -65 95 0 95 0 0 65 0 65 -95 0 -95 0 0 -65z",
    style: {
      fill: "#5270A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770 675 l0 -65 95 0 95 0 0 65 0 65 -95 0 -95 0 0 -65z",
    style: {
      fill: "#5270A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1060 675 l0 -65 90 0 90 0 0 65 0 65 -90 0 -90 0 0 -65z",
    style: {
      fill: "#5270A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210 465 l0 -65 90 0 90 0 0 65 0 65 -90 0 -90 0 0 -65z",
    style: {
      fill: "#5270A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490 465 l0 -65 95 0 95 0 0 65 0 65 -95 0 -95 0 0 -65z",
    style: {
      fill: "#5270A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770 465 l0 -65 95 0 95 0 0 65 0 65 -95 0 -95 0 0 -65z",
    style: {
      fill: "#5270A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1060 465 l0 -65 90 0 90 0 0 65 0 65 -90 0 -90 0 0 -65z",
    style: {
      fill: "#5270A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210 255 l0 -65 90 0 90 0 0 65 0 65 -90 0 -90 0 0 -65z",
    style: {
      fill: "#5270A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490 255 l0 -65 95 0 95 0 0 65 0 65 -95 0 -95 0 0 -65z",
    style: {
      fill: "#5270A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770 255 l0 -65 95 0 95 0 0 65 0 65 -95 0 -95 0 0 -65z",
    style: {
      fill: "#5270A9"
    }
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCalendrier, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/calendrier.b09f66b0.svg";
export { ForwardRef as ReactComponent };